<template>
  <li
    v-editable="blok"
    :class="[spaceBetweenItems, computedFontStyle, computedTextColor]"
  >
    <template v-if="blok.multi_text && blok.multi_text.length !== 0">
      <StoryblokComponent
        v-for="childBlok in blok.multi_text"
        :key="childBlok._uid"
        :blok="childBlok"
      />
    </template>
    <span v-else class="mb-0">
      {{ decodedText }}
    </span>
  </li>
</template>

<script lang="ts" setup>
import useTextModifiers from '@/composables/useTextModifiers'

import type {
  SbListItemStoryblok,
  SbPluginInfermedicaFontPicker,
} from '@/types'

const { decodeAndReplaceText } = useTextModifiers()

interface Props {
  blok: SbListItemStoryblok
  space: string
  font: SbPluginInfermedicaFontPicker | void
}
const props = withDefaults(defineProps<Props>(), {
  space: '4',
  font: () => {},
})

const spaceBetweenItems = computed(() => `mb-${props.space}` || 'mb-4')
const computedFontStyle = computed(
  () => props.font?.font.value ?? 'paragraph--m',
)
const computedTextColor = computed(() => `text-${props.font?.color_name}` ?? '')
const decodedText = computed(
  () => props.blok.text && decodeAndReplaceText(props.blok.text),
)
</script>
